import { React, PropTypes, Drawer as AntdDrawer, FelaComponent, childrenPropType } from '../dependencies';

const drawerRule = () => ({
    '& .ant-drawer-content-wrapper': {
        maxWidth: '400px',
    },

    '& .ant-drawer-header': {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1,
    },
    '& .ant-drawer-body': {
        marginTop: '55px',
    },
});

const Drawer = ({ title, visible, children, onClose }) => (
    <FelaComponent
        rule={drawerRule}
        render={({ className }) => (
            <AntdDrawer
                className={className}
                title={title}
                placement="left"
                closable
                onClose={onClose}
                width={null}
                visible={visible}
            >
                {children}
            </AntdDrawer>
        )}
    />
);

Drawer.propTypes = {
    title: PropTypes.string,
    visible: PropTypes.bool.isRequired,
    children: childrenPropType,
    onClose: PropTypes.func.isRequired,
};

Drawer.defaultProps = {
    title: null,
    children: null,
};

export default Drawer;
